import { render, staticRenderFns } from "./DeadlinesOrdersNotesPortlet.vue?vue&type=template&id=9132d982&"
import script from "./DeadlinesOrdersNotesPortlet.vue?vue&type=script&lang=js&"
export * from "./DeadlinesOrdersNotesPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports